import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import s from './App.module.scss';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './redux/store';
import Loader from 'component/Loader';

import 'modern-normalize/modern-normalize.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <BrowserRouter>
          <App className={s.pageBody} />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
